import { createContext } from "react"

const PeopleToVisitManagementContext = createContext();

export default PeopleToVisitManagementContext;